// extracted by mini-css-extract-plugin
export var dataCell = "_ke-2";
export var dataRow = "_ke-0";
export var headerRow = "_ke-1";